
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LayoutDirective } from '../services/layout.directive';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-dayselectiontabs',
  templateUrl: './dayselectiontabs.component.html',
  styleUrls: ['./dayselectiontabs.component.css'],
  imports: [
    RouterLinkActive,
    RouterLink,
    LayoutDirective
],
  standalone: true
})
export class DayselectiontabsComponent {
  @Input() public eventdays;
  @Input() public viewForRouter;
  @Input() public viewForRole;

  constructor(public layoutService: LayoutService) { }
}